import style from "./NotFound.module.scss";

export default function NotFound() {
  return (
    <div className={style.container}>
      <p>404 | NOT FOUND</p>
    </div>
  );
}
